import { BaseController } from 'controllers/BaseController'
import { GetContext } from 'store/storeUtils'
import { ProjectOperationsAPI } from './GeometryLogs.api'
import { IProjectOperationsAPI } from './GeometryLogs.types'

export class ProjectOperationsController extends BaseController<IProjectOperationsAPI> {
  private _currentPage = 0
  private _hasMore = true

  public get hasMoreItems() {
    return this._hasMore
  }

  public get currentPage() {
    return this._currentPage
  }

  constructor() {
    super((onRequestChange) => {
      const { partyId, projectId } = GetContext()

      return new ProjectOperationsAPI(partyId, projectId, onRequestChange)
    })
  }

  public async GetProjectOperations() {
    try {
      return await this.api.GetProjectOperations()
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async GetGeometryOperationsPage(page: number, pageSize = 200) {
    try {
      this._currentPage = page

      const ret = this.GetGeometryOperations(page, pageSize)
      return ret
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async GetGeometryOperations(page = 0, pageSize = 200) {
    try {
      this._currentPage = page

      const ret = await this.api.GetGeometriesOperations(page, pageSize)

      this._hasMore = ret._meta.totalPages > page

      return ret
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async DeleteAllProjectOperationLogs() {
    try {
      return await this.api.RemoveAllGeometryLogs()
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async GetOperationsSummary() {
    try {
      return await this.api.GetOperationsSummary()
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
